import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { LANGUAGES } from "../i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

/**
 * Language switcher dropdown.
 * Variant controls how it looks against light vs dark backgrounds.
 *   - "topbar": white-on-dark (used inside the app top bar)
 *   - "login":  dark-on-light (used inside the login card)
 */
export default function LanguageSwitcher({ variant = "topbar" }) {
  const { i18n } = useTranslation();
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  const isLogin = variant === "login";
  const triggerCls = isLogin
    ? "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-slate-200 hover:border-cyan-400 hover:bg-cyan-50/50 text-slate-700 text-xs font-semibold transition"
    : "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/15 hover:border-cyan-300/50 hover:bg-white/10 text-white/90 text-xs font-semibold transition";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={triggerCls} data-testid="lang-switcher-trigger" type="button">
          <Globe size={14} />
          <span>{current.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onSelect={() => i18n.changeLanguage(l.code)}
            data-testid={`lang-option-${l.code}`}
            className={l.code === current.code ? "font-semibold text-cyan-700" : ""}
          >
            <span className="mr-2 text-xs text-slate-400">{l.short}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
